'use strict';

module.exports = {
  Promise: typeof Promise !== 'undefined' ? Promise : null
};
//# sourceMappingURL=promise.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/exceljs-lightweight/dist/es5/utils/promise.js
// module id = AL/q
// module chunks = 32